function scrollToSection(targetDataId, targetSectionIndex) {
    const sections = document.querySelectorAll(`[data-id="${targetDataId}"]`);
    if (sections.length === 0) return;
  
    const section = sections[targetSectionIndex - 1];
    const sectionId = section.id;
    const header = document.querySelector('.site-header');
    const headerOffset = header ? header.offsetHeight : 0;
  
    const sectionPosition = section.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = sectionPosition - headerOffset;
  
    const startPosition = window.scrollY;
    const distance = offsetPosition - startPosition;
    const duration = 1000;
  
    let startTime = null;
  
    function animation(currentTime) {
      if (!startTime) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easeInOutQuad(progress);
  
      window.scrollTo({
        top: startPosition + distance * ease,
        behavior: 'auto'
      });
  
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }
  
    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }
  
    requestAnimationFrame(animation);
  }
  
  document.querySelectorAll('.grid-link__content-link').forEach(link => {
    link.addEventListener('click', (event) => {

      event.preventDefault();
      const targetDataId = link.getAttribute('data-target');
      const targetSectionIndex = parseInt(link.getAttribute('data-target-section'), 10);
      console.log(targetDataId, targetSectionIndex);
      if (targetDataId && targetSectionIndex) {
        scrollToSection(targetDataId, targetSectionIndex);
      }
    });
  });